import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { Icon } from "@iconify/react";
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
//Miscellaneous
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Accordion, TabContainer, Nav, NavItem, NavLink, TabContent, TabPane } from 'react-bootstrap'

const graphFilter = ['new-deposit', 'old-deposit', 'total-deposit', 'bet-amt', 'effective-amt', 'win-lose'];

export class MobileDataComparison extends Component {
    constructor(props) {
      super(props);
      this.state = {
        chartData: {},
        options: {},
        chartTab: 0,
        chartType: 0,
        chartTypeLabel: "New Registered Deposit",
        pageShow: "amount",
        showModal: false,
        filterShow: '',
        chartLastMonth: [],
        chartThisMonth: [],
      }
    };

    componentDidMount(){
        this.fetchData(0, 0);
      }

  fetchData = (type = null, graph = null) => {
    let data = {};
    data.type = type === 0 ? 'amount' : 'headcount';
    data.graph = graphFilter[graph];
    this.props.getDashboard(data);
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.dashboard_data !== undefined && nextProps.dashboard_data !== this.props.dashboard_data){
      if(nextProps.dashboard_data.responseCode === 200 && nextProps.dashboard_data.msgType === "success"){
        this.setState({
          loading: false,
          total_days: nextProps.dashboard_data.data.total_days,
          chartLastMonth: nextProps.dashboard_data.data.filtered_chart_last_month,
          chartThisMonth: nextProps.dashboard_data.data.filtered_chart_this_month
        });
      }
    }
    return true;
  }

    toggleModal = () => 
    {
        this.setState({
            showModal: !this.state.showModal,
        });
    };

    chartTabHandler = (tab) => {
        this.setState({
          chartTab: tab,
          chartType: 0,
          loading: true
        }, this.fetchData(tab, 0));
      };
    
      chartTypeHandler = (i, label) => {
        this.setState({
          chartType: i,
          chartTypeLabel: label,
          loading: true
        }, this.fetchData(this.state.chartTab, i));
      };

      handleGraph = () => {
        let data = [];
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

        if(this.state.total_days > 0){
          for(let i = 1; i <= this.state.total_days; i++){
            let lmonth = this.state.chartLastMonth[i] ? parseFloat(new Intl.NumberFormat("en-US", num_format).format(this.state.chartLastMonth[i])) : 0;
            let tmonth = this.state.chartThisMonth[i] ? parseFloat(new Intl.NumberFormat("en-US", num_format).format(this.state.chartThisMonth[i])) : 0;
            data.push({ day: i, LMonth: lmonth, TMonth: tmonth });
          }
        }
        return data;
      }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
          return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
      };

    render() {
        const { t } = this.props;
        const slateGray = "#8b9ccb";
        let lastMonthLabel = t('dashboard.last-month');
        let thisMonthLabel = t('dashboard.this-month');
        if(this.state.chartTab === 0){
          lastMonthLabel += ' (USD)';
          thisMonthLabel += ' (USD)';
        }

        const chartData = this.handleGraph();
        const chartTypesOne = [
            { id: 1, label: t("dashboard.new-deposit") },
            { id: 2, label: t("dashboard.old-deposit")},
            // { id: 3, label: "First Deposit" },
            { id: 3, label: t("dashboard.total-deposit") },
            { id: 4, label:t("dashboard.bet-amount") },
            { id: 5, label: t("dashboard.effective-amount") },
            { id: 6, label: t("dashboard.win-lose") }
          ];
      
          const chartTypesTwo = [
            { id: 1, label: t("dashboard.new-deposit") },
            { id: 2, label: t("dashboard.old-deposit") }
            // { id: 3, label: "First Deposit" },
          ];

        return (

                <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto"> 
                    <TabContainer defaultActiveKey="amount">
                    <div className={`filters-m-col ${this.state.filterShow ? 'show' : ''}`} >
                        <MobileSubHeader
                            className="bg-white"
                            closeModalHandler={this.props.toggleShowData}
                            header={t("dashboard.data-compare")}
                            modalHeader={true}
                            modalHandler={this.props.showInfoHandler}
                            style={{ justifyContent: "unset" }}
                        />
                        <div className="delegate-deposit-wrap mt-3">
                            <Nav className='mobile delegate-deposit-nav' variant="pills">
                                <NavItem>
                                    <NavLink eventKey="amount" id="amount" onClick={() => this.chartTabHandler(0)}>{t("dashboard.amount")}</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink eventKey="no_ppl" id="no_ppl" onClick={() => this.chartTabHandler(1)}>{t("dashboard.no-people")}</NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </div>
                    <TabContent className='tab-content-container'>
                        <TabPane eventKey="amount" >
                          
                            <div className="db-col col-12 p-3 bg-white">
                                <div className="mw-100 recharts-line-none" style={{overflowX: "auto"}}>
                                <ResponsiveContainer width={1920} height={1080}>
                            <LineChart
                              width="100%"
                              height={700}
                              data={chartData}
                              margin={{
                                top: 15,
                                left: 15,
                                right: 15,
                              }}
                            >
                              <XAxis dataKey="day" type="number" domain={[1, 31]} tickCount={31} tickSize={5} tickLine={false} axisLine={{ stroke: slateGray }} label={{ fill: slateGray }}  />
                              <Tooltip labelFormatter={() => this.state.chartTypeLabel} cursor={{ stroke: '#F6FAFF', strokeWidth: 20 }} wrapperStyle={{ outline: "none" }} />
                              <Legend iconSize={40} />
                              <Line  type="monotone" dot={{ strokeWidth: 2 }} dataKey="LMonth" name={lastMonthLabel} stroke="#4A89FC" />
                              <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="TMonth" name={thisMonthLabel} stroke="#04BE02" />
                            </LineChart>
                          </ResponsiveContainer>
                            </div>
                            <ResponsiveContainer width="100%" height={80} >
                                <LineChart
                                width="100%"
                                height="auto"
                                margin={{
                                    top: 15,
                                    left: 15,
                                    right: 15,
                                }}
                                >
                                <Legend iconSize={40} />
                                <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="LMonth" name={lastMonthLabel} stroke="#4A89FC" />
                                <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="TMonth" name={thisMonthLabel} stroke="#04BE02" />
                                </LineChart>
                            </ResponsiveContainer>
                            <div className="db-chart-footer">
                            {this.state.chartTab === 0 ?
                              chartTypesOne &&
                              chartTypesOne.map((item, index) => (
                                <button
                                  type="button"
                                  key={index}
                                  className={`${this.state.chartType === index ? "active" : ""}`}
                                  onClick={() => this.chartTypeHandler(index, item.label)}
                                >
                                  <p>{item.label}</p>
                                </button>
                              )) : this.state.chartTab === 1 ?
                                chartTypesTwo &&
                                chartTypesTwo.map((item, index) => (
                                  <button
                                    type="button"
                                    key={index}
                                    className={`${this.state.chartType === index ? "active" : ""}`}
                                    onClick={() => this.chartTypeHandler(index, item.label)}
                                  >
                                    <p>{item.label}</p>
                                  </button>
                                )) : <></>
                            }
                          </div>
                        </div>
                        </TabPane>
                        <TabPane eventKey="no_ppl">
                        <div className="db-col col-12 p-3 bg-white">
                        <div className="mw-100 recharts-line-none" style={{overflowX: "auto"}}>
                        <ResponsiveContainer width={1920} height={1080} >
                            <LineChart
                             width="100%"
                             height={700}
                              data={chartData}
                              margin={{
                                top: 15,
                                left: 15,
                                right: 15,
                              }}
                            >
                              <XAxis dataKey="day" type="number" domain={[1, 31]} tickCount={31} tickSize={5} tickLine={false} axisLine={{ stroke: slateGray }} label={{ fill: slateGray }} />
                              <Tooltip labelFormatter={() => this.state.chartTypeLabel} cursor={{ stroke: '#F6FAFF', strokeWidth: 20 }} wrapperStyle={{ outline: "none" }} />
                              <Legend iconSize={40} />
                                <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="LMonth" name={lastMonthLabel} stroke="#4A89FC" />
                                <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="TMonth" name={thisMonthLabel} stroke="#04BE02" />
                            </LineChart>
                          </ResponsiveContainer>
                          </div>
                          <ResponsiveContainer width="100%" height={80} >
                                <LineChart
                                width="100%"
                                height="auto"
                                margin={{
                                    top: 15,
                                    left: 15,
                                    right: 15,
                                }}
                                >
                                <Legend iconSize={40} />
                                <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="LMonth" name={lastMonthLabel} stroke="#4A89FC" />
                                <Line type="monotone" dot={{ strokeWidth: 2 }} dataKey="TMonth" name={thisMonthLabel} stroke="#04BE02" />
                                </LineChart>
                            </ResponsiveContainer>
                          <div className="db-chart-footer">
                            {this.state.chartTab === 0 ?
                              chartTypesOne &&
                              chartTypesOne.map((item, index) => (
                                <button
                                  type="button"
                                  key={index}
                                  className={`${this.state.chartType === index ? "active" : ""}`}
                                  onClick={() => this.chartTypeHandler(index, item.label)}
                                >
                                  <p>{item.label}</p>
                                </button>
                              )) : this.state.chartTab === 1 ?
                                chartTypesTwo &&
                                chartTypesTwo.map((item, index) => (
                                  <button
                                    type="button"
                                    key={index}
                                    className={`${this.state.chartType === index ? "active" : ""}`}
                                    onClick={() => this.chartTypeHandler(index, item.label)}
                                  >
                                    <p>{item.label}</p>
                                  </button>
                                )) : <></>
                            }
                          </div>
                        </div>
                        </TabPane>
                    </TabContent>
                </TabContainer>
                    </section>
                    );
                }
            }


export default (withNamespaces('translation')(MobileDataComparison));